module.exports = __webpack_public_path__ + "assets/img/zhuangxiu.8a865bea.png";